


















import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseTextarea from '@/base/app/components/atoms/BaseTextarea.vue';

import {
  ContentVersionValue,
  PropsContentVersionForm,
  useContentVersionForm,
} from './ContentVersionFormComposable';

type Props = PropsContentVersionForm;

export default defineComponent({
  name: 'ContentsContentVersion',
  components: { BaseTextarea },
  inheritAttrs: false,
  model: { prop: 'value', event: 'submit' },
  props: {
    value: { type: Object as PropType<ContentVersionValue>, required: true },
  },
  emits: ['submit'],
  setup(props: Props, { emit }: SetupContext) {
    return useContentVersionForm(props, emit);
  },
});
